import { render, staticRenderFns } from "./userDialogContent.vue?vue&type=template&id=00c933cd"
import script from "./userDialogContent.vue?vue&type=script&lang=js"
export * from "./userDialogContent.vue?vue&type=script&lang=js"
import style0 from "./userDialogContent.vue?vue&type=style&index=0&id=00c933cd&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports